import { createContext } from 'react';

export const ReportStudioHandoffContext = createContext(null);
